/* Devocione V7.2 — independent announcement rotation, editor-aware. */
(() => {
  'use strict';
  if (customElements.get('dv7-announcements')) return;
  class Announcements extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.messages = [...this.querySelectorAll('[data-dv7-ann-message]')];
      this.index = 0; this.userPaused = false; this.motionOverride = false; this.hovered = false; this.editorSelected = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.pauseButton = this.querySelector('[data-dv7-ann-pause]');
      this.querySelector('[data-dv7-ann-controls]').hidden = this.messages.length < 2;
      this.querySelector('[data-dv7-ann-prev]').hidden = this.messages.length < 2;
      this.pauseButton.hidden = this.dataset.autoplay !== 'true';
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('[data-dv7-ann-prev]')) this.go(this.index - 1);
        if (event.target.closest('[data-dv7-ann-next]')) this.go(this.index + 1);
        if (event.target.closest('[data-dv7-ann-pause]')) {
          const paused = this.userPaused || (this.motion.matches && !this.motionOverride);
          this.userPaused = !paused; if (paused) this.motionOverride = true;
          this.refreshPause(); this.schedule();
        }
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && matchMedia('(hover:hover)').matches) { this.hovered = true; this.schedule(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => { clearTimeout(this.focusTimer); this.focusTimer = setTimeout(() => this.schedule(), 0); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { this.motionOverride = false; this.refreshPause(); this.schedule(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.messages.findIndex(item => item.dataset.blockId === event.detail?.blockId);
        if (index >= 0) { this.editorSelected = true; this.go(index); }
      }, options);
      document.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
      this.go(0);
    }
    go(index) {
      const count = this.messages.length;
      if (!count) return;
      this.index = (index + count) % count;
      this.messages.forEach((item, i) => {
        const active = i === this.index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', String(!active)); item.inert = !active;
      });
      this.refreshPause(); this.schedule();
    }
    refreshPause() {
      const paused = this.userPaused || (this.motion.matches && !this.motionOverride);
      this.pauseButton.setAttribute('aria-pressed', String(paused));
      this.pauseButton.setAttribute('aria-label', paused ? 'Resume announcements' : 'Pause announcements');
      this.pauseButton.textContent = paused ? '▷' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      const focus = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
      if (!this.isConnected || this.dataset.autoplay !== 'true' || this.messages.length < 2 || this.userPaused || (this.motion.matches && !this.motionOverride) || this.hovered || focus || this.editorSelected || document.hidden) return;
      this.timer = setTimeout(() => this.go(this.index + 1), Math.max(3, Math.min(30, Number(this.dataset.interval) || 7)) * 1000);
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      clearTimeout(this.timer); clearTimeout(this.focusTimer);
    }
  }
  customElements.define('dv7-announcements', Announcements);
})();
